<template>
  <b-container fluid style="text-align: center">
    <!-- <ve-line
      :data="graphInfo"
      :settings="graphSettings"
    /> -->
    <canvas id="myChart" width="400" height="400" />
  </b-container>
</template>

<script>
import VeLine from "v-charts/lib/line.common";
import { mapActions } from "vuex";
import Chart from "chart.js";

export default {
  name: "StatGraphComponent",
  components: {
    VeLine,
  },
  props: {
    graphInfo: {
      // required: true,
    },
  },
  data() {
    return {
      graphSettings: {
        lineStyle: {
          smoothMonotone: "x",
        },
      },
    };
  },
  async created() {
    if (!this.graphInfo) {
      this.$store.state.isLoading = true;
      let resultFilter = await this.statFilter(this.$route.query);
      if (!resultFilter.success) {
        // console.log("error");
      } else {
        this.graphInfo = resultFilter.result.graph_info;
      }
      this.$store.state.isLoading = false;
    }
  },
  mounted() {
    this.filterGraph();
  },
  methods: {
    ...mapActions({
      statFilter: "Account/statFilter",
    }),
    filterGraph() {
      let ctx = document.getElementById("myChart");

      let label = this.graphInfo.rows.map((el) => el.date);
      let datasets = this.graphInfo.rows.map((el, index) => {
        label: "";
      });

      var myChart = new Chart(ctx, {
        type: "line",
        data: {
          labels: label,
          datasets: [
            {
              label: "จำนวน",
              data: [12, 19, 3, 5, 2, 3],
              backgroundColor: [
                "rgba(255, 99, 132, 0.2)",
                "rgba(54, 162, 235, 0.2)",
                "rgba(255, 206, 86, 0.2)",
                "rgba(75, 192, 192, 0.2)",
                "rgba(153, 102, 255, 0.2)",
                "rgba(255, 159, 64, 0.2)",
              ],
              borderColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
              ],
              borderWidth: 1,
            },
          ],
        },
        options: {
          animation: {
            onComplete: function() {
              var ctx = this.chart.ctx;

              ctx.textAlign = "center";
              ctx.textBaseline = "bottom";

              this.chart.config.data.datasets.forEach(function(dataset) {
                ctx.fillStyle = dataset.strokeColor;
                dataset.metaDataset._points.forEach(function(p) {
                  ctx.fillText(
                    p._chart.config.data.datasets[p._datasetIndex].data[
                      p._index
                    ],
                    p._model.x,
                    p._model.y - 10
                  );
                });
              });
            },
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
      });
    },
  },
};
</script>

<style scoped></style>
